var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutBaseContent',{staticClass:"max-w-7xl"},[_c('LayoutPanel',[_c('UtilIframe',{staticClass:"mt-0 terms-iframe",attrs:{"url":_vm.compUrl}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }